import { useTranslation } from 'react-i18next';
import { Spin } from '../Ant';
import MatterRestrictionDialogs from '../dashboard/addTransaction/matterRestrictionDialogs';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTimerMatterSelect } from './useTimerMatterSelect';

interface TimerMatterSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the matter list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const TimerMatterSelect = ({ onOpenPicker, onClear }: Readonly<TimerMatterSelectProps>) => {
  const { t } = useTranslation();
  const { select, dialogs, isCheckingRestrictions } = useTimerMatterSelect();

  return (
    <>
      <SearchableSelect
        {...select}
        ariaLabel={t('matter:matter')}
        placeholder={t('matter:selectMatter')}
        searchPlaceholder={t('matter:search')}
        onSearchIconClick={onOpenPicker}
        onClear={onClear}
        data-field="matter"
        data-testid="timer-matter-select-button"
      />
      <MatterRestrictionDialogs {...dialogs} />
      {isCheckingRestrictions && <Spin fullscreen />}
    </>
  );
};

export default TimerMatterSelect;
